import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { MailingAddressReview } from "@/components/MailingAddressReview";
import { MailNowOffer } from "@/components/MailNowOffer";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export const AddressFixDialog = ({ lead, onClose, onFixed }) => {
  const [mailing, setMailing] = useState(null);
  const [fixedNow, setFixedNow] = useState(false);
  useEffect(() => {
    if (!lead) return;
    setMailing(null); setFixedNow(false);
    api.get(`/prospects/${lead.id}/postcard-preview`).then((r) => setMailing(r.data.mailing))
      .catch((e) => { toast.error(apiError(e)); onClose(); });
  }, [lead, onClose]);
  return (
    <Dialog open={!!lead} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="address-fix-dialog">
        <DialogHeader>
          <DialogTitle>Fix mailing address</DialogTitle>
          <DialogDescription>{lead?.name} · {lead?.address}{lead?.mlo ? ` · ${lead.mlo}` : ""}</DialogDescription>
        </DialogHeader>
        {!lead ? null : !mailing ? <div className="flex justify-center p-8"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div> : (
          <div className="space-y-3">
            <MailingAddressReview key={JSON.stringify(mailing)} prospectId={lead.id} mailing={mailing}
              onUpdated={(m) => { setMailing({ ...mailing, ...m }); if (["verified", "corrected"].includes(m.status)) { setFixedNow(true); onFixed?.(); } }} />
            {fixedNow && <MailNowOffer ids={[lead.id]} testId="fix-mail-now" />}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
